<template>
    <div class="white">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MiddleContent",
    };
</script>

<style  scoped>
    .white {
        margin: auto;
        width: calc(100% - 250px);
        height: calc(100% - 40px);
        background-color: #fff;
        border-radius: 8px;
    }
</style>